// extracted by mini-css-extract-plugin
module.exports = {"eventsGrid":"display_eventsGrid__ghSfV","filterScroll":"display_filterScroll__mm8Av"};